module.exports = __webpack_public_path__ + "img/testimonial-3.7fe2d4d1.jpg";